import { TrashIcon } from "vega-icons";

import { type RoleNew } from "@vega-api/generated/types/roleNew";
import { ThemedIconButton } from "@vega-core/components/Buttons/ThemedIconButton";
import { type BaseMultiSelectOption } from "@vega-core/components/Form/Controls/Dropdown/ThemedMultiselectDropdown/ThemedMultiselectDropdown";
import { m } from "@vega-core/paraglide/messages";

import {
  type CollaboratorsV2State,
  type FundVehicleTab,
} from "./collaboratorsV2Constants";
import { RoleAssignmentAccordion } from "./RoleAssignmentAccordion";

type CollaboratorsV2Props = {
  collaboratorsAccordion: CollaboratorsV2State;
  deleteCollaboratorsAccordion: (id: string) => void;
  disabledRoleIds: string[];
  handleFundVehicleTabChange: (id: string, tab: FundVehicleTab) => void;
  handleRoleChange: (id: string, selectedRole: BaseMultiSelectOption) => void;
  roles: RoleNew[];
};

export const CollaboratorsV2 = ({
  collaboratorsAccordion: { id, index, selectedRole, fundVehicleTab },
  deleteCollaboratorsAccordion,
  disabledRoleIds,
  handleFundVehicleTabChange,
  handleRoleChange,
  roles,
}: CollaboratorsV2Props) => (
  <div className="rounded-lg border border-border/secondary">
    <div className="flex items-center justify-between px-4 py-3 bg-background/subtle rounded-t-lg">
      <span className="heading-6 text-text/secondary">
        {m.settings_collaborators_inviteCollaboratorAssignment()}
      </span>
      {index > 1 && (
        <ThemedIconButton
          ariaLabel={m.common_delete()}
          dataTestId={`delete-assignment-${id}`}
          icon={<TrashIcon className="w-4 h-4" />}
          onClick={() => deleteCollaboratorsAccordion(id)}
          size="small"
          variant="noBackground"
        />
      )}
    </div>
    <RoleAssignmentAccordion
      disabledRoleIds={disabledRoleIds}
      fundVehicleTab={fundVehicleTab}
      onFundVehicleTabChange={(tab) => handleFundVehicleTabChange(id, tab)}
      onRoleChange={(role) => handleRoleChange(id, role)}
      roles={roles}
      selectedRole={selectedRole}
    />
  </div>
);
